import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';

const DeleteCourses = () => {
    const [courses, setCourses] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchDeletedCourses();
    }, []);

    const fetchDeletedCourses = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/course/deleted');
            const data = await response.json();
            setCourses(data);
        } catch (error) {
            console.error('Error fetching deleted courses:', error);
        }
    };

    const handleRestore = async (courseId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to restore this course?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, restore it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/course/restore/${courseId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        // Update local state after successful restoration
                        const updatedCourses = courses.filter(course => course.id !== courseId);
                        setCourses(updatedCourses);
                        
                        // Show success message
                        Swal.fire({
                            title: "Restored!",
                            text: "The course has been restored.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to restore course');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to restore the course.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error restoring course:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to restore the course.",
                        icon: "error"
                    });
                }
            }
        });
    };

    const handlePermanentDelete = async (courseId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to permanently delete this course? This action cannot be undone!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it permanently!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/course/delete/permanent/${courseId}`, {
                        method: 'DELETE'
                    });
                    if (response.ok) {
                        // Update local state after successful deletion
                        const updatedCourses = courses.filter(course => course.id !== courseId);
                        setCourses(updatedCourses);
                        
                        // Show success message
                        Swal.fire({
                            title: "Deleted!",
                            text: "The course has been permanently deleted.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to delete course permanently');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to delete the course permanently.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error deleting course permanently:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to delete the course permanently.",
                        icon: "error"
                    });
                }
            }
        });
    };

    // Filter courses based on search term
    const filteredCourses = courses.filter(course => 
        (course.courseName && course.courseName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (course.university && course.university.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (course.duration && course.duration.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const handleSearchSubmit = (e) => {
        e.preventDefault(); // Prevent form submission
    };

    return (

        <div>

            <AdminDashboard />

            <div className='AllViews-admin-course'>

                <div className="search-icon-admin admin-course-search">

                    <h1>DELETE COURSES</h1>
                    <form onSubmit={handleSearchSubmit}>
                        <input 
                            type="text" 
                            placeholder='Search Item' 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                   
                </div>

                <div className="scroller-box">
                    <div className="table-course">
                    <table>
                            <thead>
                                <tr>
                                    <th>Course Name</th>
                                    <th>Institute Name</th>
                                    <th>Start Date</th>
                                    <th>Duration</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredCourses.map((course) => (
                                    <tr key={course.id}>
                                        <td>{course.courseName}</td>
                                        <td>{course.university}</td>
                                        <td>{new Date(course.startDate).toLocaleDateString('en-CA')}</td>
                                        <td>{course.duration}</td>
                                        <td>
                                            <a href="#!" id='view-website'>WEBSITE</a>
                                        </td>
                                        <td id='action-buttons'>
                                            <a href="#!" id='restore-details' onClick={() => handleRestore(course.id)}>RESTORE</a>
                                            <a href="#!" id='del-details' onClick={() => handlePermanentDelete(course.id)}>DELETE</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>

                </div>

            </div>



        </div>

    )

}

export default DeleteCourses